import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const CxResponses = Loadable({
  loader: () => import("./CxResponses"),
  loading: Loading
})
